// @ts-nocheck
/* eslint-disable */
import { store } from "~/state/store";
import SceneFeature from "../feature";
import SceneCoords from "~/scene/common/coords";
import { watch, watchCoordinates } from "~/state/util";
import { Unsubscribe } from "redux";

interface IBBox {
	min: SceneCoords;
	max: SceneCoords;
	empty: boolean;
}

export default class SceneGeometrySmart extends SceneFeature {
	_storeUnsubscribe: Unsubscribe;

	_bbox: IBBox;

	constructor(scene, itemId, type, id, coords, options) {
		super(scene, itemId);

		this._type = type;
		this._id = id || Math.random();
		this._coords = coords;
		this._geometries = [];
		this._appended = false;
		this._storeUnsubscribe = null;
		this._options = {
			minDist: 3
		};

		this._pixelsData = {
			pixels: [],
			zoom: 0,
			sizeKey: "",
			fullPixels: [],
			indexes: []
		};
		this._bbox = {
			min: null,
			max: null,
			empty: true,
		};

		for (let key in options) {
			this._options[key] = options[key];
		}

		this._allNodesCbData = null;

		if (this._coords) {
			this._prepareVisibleParts();
		}
	}

	get appended() {
		return this._appended;
	}

	set appended(append) {
		this._appended = append;

		if (append) {
			const wt = watch(store.getState, "map", watchCoordinates);

			this._storeUnsubscribe = store.subscribe(wt((newMap, oldMap) => {
				if (
					newMap.longitude !== oldMap.longitude
					|| newMap.latitude !== oldMap.latitude
					|| newMap.zoom !== oldMap.zoom
				) {
					this._redraw();
				}
			}));
		} else {
			this._storeUnsubscribe?.();
			this._storeUnsubscribe = null;
		}
	}

	// moje
	get featureInfo() {
		return {
			name: "SceneGeometrySmart",
			type: "geometry"
		};
	}

	get geometries() {
		return this._geometries;
	}

	getCreateData() {
		let rd = super.getCreateData();

		rd.type = this._type;
		rd.id = this._id;
		rd.coords = this._coords;
		rd.geometries = this._geometries;
		rd.options = this._options;

		return rd;
	}

	// eventy

	setOptions(options) {
		for (let p in options) { this._options[p] = options[p]; }

		this._geometries.forEach(g => {
			g.setOptions(this._options);
		});
	}

	/**
	 * Vycisteni geometrie.
	 */
	clear() {
		this._bbox = {
			min: null,
			max: null,
			empty: true,
		};

		this._geometries = [];
	}

	setCoords(coords) {
		this._coords = coords;
		this._prepareVisibleParts();
		this._redraw();

		//this._onChange(this._scene.featureEvent("geometrySetCoords", true, true), arguments);
	}

	// gety
	getId() {
		return this._id;
	}

	getType() {
		return this._type;
	}

	getCoords() {
		return this._coords;
	}

	getPixels(full) {
		let size = this._scene.getSize();
		let sizeKey = size.x + "|" + size.y;
		const { longitude, latitude, zoom } = store.getState().map;
		let posKey = longitude + "|" + latitude + "|" + zoom;

		// cache
		if (sizeKey == this._pixelsData.sizeKey && posKey == this._pixelsData.posKey) {
			return full ? this._pixelsData.fullPixels : this._pixelsData.pixels;
		}

		this._prepareVisibleParts();
		return full ? this._pixelsData.fullPixels : this._pixelsData.pixels;
	}

	getBBoxWgs84() {
		return this._bbox;
	}

	getIndexes() {
		return this._pixelsData.indexes;
	}

	getOptions() {
		return this._options;
	}

	getNodes(cb, scope) { //FIXME
		this._onChange(this._scene.featureEvent("geometryGetNodes", true, true), arguments);
	}

	/**
	 * Ziskani SVG nodu geometrie - synchronni verze.
	 *
	 * @return {Array} pole s geometriemi
	 */
	getNodesSync() {
		return this._onChange(this._scene.featureEvent("geometryGetNodesSync", true, true), arguments);
	}

	getAllNodes(cb, scope?) {
		this._allNodesCbData = {
			cb,
			scope
		};
	}

	rebind() {
		// mame nove geometrie, mame callback?
		if (this._allNodesCbData) {
			// pro kazdou geometrii zavolame
			this._geometries.forEach(geom => {
				geom.getNodes(nodes => {
					this._allNodesCbData.cb.apply(this._allNodesCbData.scope || this, [nodes, geom]);
				});
			})
		}
	}

	computeCenterZoom(usePadding) {
		let coords = [];

		for (let i = 0; i < this._coords.length; i++) {
			let item = this._coords[i];

			if (!(item instanceof Array)) { item = [item]; }

			for (let j = 0; j < item.length; j++) {
				let c = item[j];

				if (!(c instanceof SceneCoords)) { continue; }

				coords.push(c);
			}
		}

		return this._scene.computeCenterZoom(coords, usePadding);
	}

	getBBox() {
		let output = {
			x: 0,
			y: 0,
			width: 0,
			height: 0
		};

		if (this._bbox.min && this._bbox.max) {
			let minBB = this._scene.coordsToPixel(this._bbox.min);
			let maxBB = this._scene.coordsToPixel(this._bbox.max);
			let size = this._scene.getSize();

			output.x = Math.round(Math.min(minBB.x, maxBB.x) + size.x / 2);
			output.y = Math.round(Math.min(minBB.y, maxBB.y) + size.y / 2);
			output.width = Math.round(Math.abs(maxBB.x - minBB.x));
			output.height = Math.round(Math.abs(maxBB.y - minBB.y));
		}

		return output;
	}

	isGeometryVisible() {
		// bbox style
		let mapSize = this._scene.getSize();
		let bbox = this.getBBox();
		let mapArea = {
			x: 0,
			y: 0,
			width: mapSize.x,
			height: mapSize.y
		};

		return (this._isIntersection(mapArea, bbox));
	}

	redraw() {
		this._prepareVisibleParts();

		return this._geometries;
	}

	// private
	_isIntersection(bbox1, bbox2) {
		let ltx = Math.max(bbox1.x, bbox2.x);
		let lty = Math.max(bbox1.y, bbox2.y);
		let rbx = Math.min(bbox1.x + bbox1.width, bbox2.x + bbox2.width);
		let rby = Math.min(bbox1.y + bbox1.height, bbox2.y + bbox2.height);

		// sirka a vyska pruseciku musi byt vetsi jak 0
		let width = Math.abs(rbx - ltx);
		let height = Math.abs(rby - lty);

		if (ltx <= rbx && lty <= rby && width * height > 0) {
			return true;
		}
		else {
			return false;
		}
	}

	_prepareVisibleParts() {
		let size = this._scene.getSize();
		let sizeKey = size.x + "|" + size.y;
		const { longitude, latitude, zoom } = store.getState().map;
		let posKey = longitude + "|" + latitude + "|" + zoom;
		let minDist = this._options.minDist;
		let offset = size.clone().scale(0.5);
		let rb = offset.clone();
		let lt = rb.clone().scale(-1);
		let result = [];
		let pixels = [];
		let coords = [];
		let indexes = [];
		let fullPixels = [];
		let geometriesNum = -1;

		while (this._geometries.length) {
			this._geometries.pop().destroy();
		}

		let coordsArray = this._coords[0] instanceof SceneCoords ? [this._coords] : this._coords;

		coordsArray.forEach((c) =>{
			let prev = null;
			let prevInMap = false;
			let nextInMap = false;
			let firstInMap = false;
			let lastInMap = false;

			if (geometriesNum < 0 || (geometriesNum >= 0 && pixels[geometriesNum].length)) { // pokud mame nejakou predchozi cast, zacneme novou, pokud je cast prazdna, pridavame do aktualni
				geometriesNum++;
				pixels[geometriesNum] = [];
				coords[geometriesNum] = [];
				indexes[geometriesNum] = [];
			}

			if (c.length > 100) { // pokud mame vice jak 100 bodu delame magii
				let startIndex = geometriesNum;
				let endIndex = geometriesNum;

				for (let i = 0; i < c.length; i++) {
					let itemC = c[i];
					let inMap = true;
					let item = itemC;

					if (itemC instanceof SceneCoords) { // souradnice
						item = this._scene.coordsToPixel(itemC);
						let nextItem = i+1 <= c.length-1 ? this._scene.coordsToPixel(c[i+1]) : null;
						let lastDistance = prev ? prev.distance(item) : 0;

						if (!(item.x >= lt.x && item.x <= rb.x && item.y >= lt.y && item.y <= rb.y)) { // zkontrolujeme, zda je bod v mape
							inMap = prevInMap ? true : false; // pokud je to 1. bod ktery videt nejde a predchozi byl v mape, tak take jeste pridame
							prevInMap = false; // oznacime, ze neni v mape
						}
						else {
							prevInMap = true;
						}

						if (!inMap && nextItem && (nextItem.x >= lt.x && nextItem.x <= rb.x && nextItem.y >= lt.y && nextItem.y <= rb.y)) { // kontrola, zda nasledujici bod bude v mape, ale aktualni neni
							inMap = true;
							prevInMap = true;
							nextInMap = true;
							if (pixels[geometriesNum].length) { // pokud mame nejakou predchozi cast, zacneme novou, pokud je cast prazdna, pridavame do aktualni
								geometriesNum++;
								pixels[geometriesNum] = [];
								coords[geometriesNum] = [];
								indexes[geometriesNum] = [];
							}
						}

						// pozor - u elipsy a kruhu neni tato optimalizace zadouci
						if (!(inMap && !prevInMap) && !nextInMap && prev && lastDistance <= minDist && this._type != this._scene.GEOMETRY.ELLIPSE && this._type != this._scene.GEOMETRY.CIRCLE) {
							if (this._type == this._scene.GEOMETRY.PATH) { // pokud se jedna o PATH, musime odstranit vse k predchozimu pismenku vcetne
								let index = result.length - 1;

								while (index && typeof(result[index]) != "string") { index--; }
								result.splice(index);
							}

							fullPixels.push(item.clone());
							if (inMap) {
								indexes[geometriesNum].push(i);
							}

							continue;
						}

						prev = item.clone();
						if (inMap) {
							pixels[geometriesNum].push(prev);
							coords[geometriesNum].push(itemC);
							indexes[geometriesNum].push(i);

							if (i == 0) {
								firstInMap = true;
							}
							else if (i == c.length-1) {
								lastInMap = true;
							}
						}

						fullPixels.push(prev);
						item.plus(offset);
					}

					if (inMap) {
						result.push(item);
					}

					endIndex = geometriesNum;
				}

				if (startIndex != endIndex && firstInMap && lastInMap && this._type == this._scene.GEOMETRY.POLYGON) {
					pixels[startIndex] = pixels.pop().concat(pixels[startIndex]);
					coords[startIndex] = coords.pop().concat(coords[startIndex]);
					indexes[startIndex] = indexes.pop().concat(indexes[startIndex]);
					geometriesNum--;
				}
			}
			else { // pokud mame <= 100 bodu, bereme vsechny souradnice geometrie
				c.forEach((i,k) => {
					let pixel = this._scene.coordsToPixel(i);

					pixels[geometriesNum].push(pixel);
					coords[geometriesNum].push(i);
					indexes[geometriesNum].push(k);
					fullPixels.push(pixel);
				});
			}
		});

		if (pixels.length > 1 && !pixels[pixels.length-1].length) {
			pixels.pop();
			coords.pop();
			indexes.pop();
		}

		for (let i = 0; i < coords.length; i++) {
			if (pixels[i].length < 2) { continue; }

			let simplified = this._simplify(pixels[i], coords[i], 0.6);
			this._geometries.push(this._scene.createGeometry(this._type == this._scene.GEOMETRY.POLYGON && this._options.clickable ? this._scene.GEOMETRY.POLYGON : this._scene.GEOMETRY.POLYLINE, null, simplified.coords, this._options));
		}

		// save to cachce
		this._pixelsData.sizeKey = sizeKey;
		this._pixelsData.posKey = posKey;
		this._pixelsData.pixels = pixels;
		this._pixelsData.fullPixels = fullPixels;
		this._pixelsData.indexes = indexes;
	}

	_redraw() {
		if (this.appended) {
			this._sceneOwner.redrawSmartGeometry(this);

			this.rebind();
		}
	}

	/*
	 (c) 2013, Vladimir Agafonkin
	 Simplify.js, a high-performance JS polyline simplification library
	 mourner.github.io/simplify-js
	*/

	// to suit your point format, run search/replace for '.x' and '.y';
	// for 3D version, see 3d branch (configurability would draw significant performance overhead)

	// square distance between 2 points
	_getSqDist(p1, p2) {

		var dx = p1.x - p2.x,
			dy = p1.y - p2.y;

		return dx * dx + dy * dy;
	}

	// square distance from a point to a segment
	_getSqSegDist(p, p1, p2) {

		var x = p1.x,
			y = p1.y,
			dx = p2.x - x,
			dy = p2.y - y;

		if (dx !== 0 || dy !== 0) {

			var t = ((p.x - x) * dx + (p.y - y) * dy) / (dx * dx + dy * dy);

			if (t > 1) {
				x = p2.x;
				y = p2.y;

			} else if (t > 0) {
				x += dx * t;
				y += dy * t;
			}
		}

		dx = p.x - x;
		dy = p.y - y;

		return dx * dx + dy * dy;
	}
	// rest of the code doesn't care about point format

	// basic distance-based simplification
	_simplifyRadialDist(points, coords, sqTolerance) {

		var prevPoint = points[0],
			newPoints = [prevPoint],
			newCoords = [coords[0]],
			point,
			c;

		for (var i = 1, len = points.length; i < len; i++) {
			point = points[i];
			c = coords[i];

			if (this._getSqDist(point, prevPoint) > sqTolerance) {
				newPoints.push(point);
				newCoords.push(c);
				prevPoint = point;
			}
		}

		if (prevPoint !== point) {
			newPoints.push(point);
			newCoords.push(c);
		}

		return { points: newPoints, coords: newCoords };
	}

	_simplifyDPStep(points, coords, first, last, sqTolerance, simplified, simplifiedCoords) {
		var maxSqDist = sqTolerance,
			index;

		for (var i = first + 1; i < last; i++) {
			var sqDist = this._getSqSegDist(points[i], points[first], points[last]);

			if (sqDist > maxSqDist) {
				index = i;
				maxSqDist = sqDist;
			}
		}

		if (maxSqDist > sqTolerance) {
			if (index - first > 1) this._simplifyDPStep(points, coords, first, index, sqTolerance, simplified, simplifiedCoords);
			simplified.push(points[index]);
			simplifiedCoords.push(coords[index]);
			if (last - index > 1) this._simplifyDPStep(points, coords, index, last, sqTolerance, simplified, simplifiedCoords);
		}
	}

	// simplification using Ramer-Douglas-Peucker algorithm
	_simplifyDouglasPeucker(points, coords, sqTolerance) {
		var last = points.length - 1;

		var simplified = [points[0]];
		var simplifiedCoords = [coords[0]];
		this._simplifyDPStep(points, coords, 0, last, sqTolerance, simplified, simplifiedCoords);
		simplified.push(points[last]);
		simplifiedCoords.push(coords[last]);

		return { points: simplified, coords: simplifiedCoords };
	}

	// both algorithms combined for awesome performance
	_simplify(points, coords, tolerance, highestQuality) {

		if (points.length <= 2) return { points: points, coords: coords };

		var sqTolerance = tolerance !== undefined ? tolerance * tolerance : 1;

		points = highestQuality ? {points: points, coords: coords } : this._simplifyRadialDist(points, coords, sqTolerance);
		points = this._simplifyDouglasPeucker(points.points, points.coords, sqTolerance);

		return points;
	}
}
